import { User } from "../User/User.type";
import { Store } from "../Store/Store.type";
import { Material } from "../Material/Material.type";
import { Project } from "../Project/Project.type";
import { Department } from "../Department/Department.type";
import { AllureEquipmentRequest } from "../AllureEquipmentRequest/AllureEquipmentRequest.type";
import { ApiCallState } from "../Utils";

export type ServiceRequest = {
  id: number;
  date: string;
  requested_by: number | null;
  department_id: number | null;
  requested_to: number | null;
  requested_to_department_id: number | null;
  requested_to_project_id: number | null;
  duration_start: string;
  duration_end: string;
  driver_name: string;
  purpose: string;
  plate_number: string;
  transport_service: boolean;
  transport_from: string;
  transport_to: string;
  transport_material_id: number;
  user_id: number;
  project_id: number | null;
  is_project: boolean;
  equipment_request_id: number | null;
  service_request_items: ServiceRequestItem[];
  service_request_statuses: ServiceRequestStatus[];
  sr_prepared_by?: User;
  sr_requested_by?: Store;
  sr_requested_to?: Store;
  sr_requested_by_department?: Department;
  sr_requested_by_project?: Project;
  sr_requested_to_department?: Department;
  sr_requested_to_project?: Project;
  sr_equipment_request?: AllureEquipmentRequest;
  sr_transport_material?: Material;
  project?: Project;
  readonly createdAt: Date;
};

export type ServiceRequestItem = {
  id: number;
  service_request_id: number;
  material_id: number;
  unit: string;
  quantity: number;
  serial_number: string;
  plate_number: string;
  detail_specification: string;
  sr_material?: Material;
};

export type ServiceRequestStatus = {
  service_request_id: number;
  type: "View" | "Check" | "Approve";
  status: number;
  assigned_by: number;
  user_id: number;
  id: number;
};

export type ServiceRequestStateTypes = {
  fetchAll: ApiCallState<ServiceRequest[]>;
  fetchOne: ApiCallState<ServiceRequest | {}>;
};

export const ServiceRequestActionTypes = {
  FETCH_ALL_SERVICE_REQUEST: "FETCH_ALL_SERVICE_REQUEST",
  FETCH_ALL_SERVICE_REQUEST_RESET: "FETCH_ALL_SERVICE_REQUEST_RESET",
  FETCH_ALL_SERVICE_REQUEST_FAILURE: "FETCH_ALL_SERVICE_REQUEST_FAILURE",
  FETCH_ALL_SERVICE_REQUEST_SUCCESS: "FETCH_ALL_SERVICE_REQUEST_SUCCESS",

  FETCH_ONE_SERVICE_REQUEST: "FETCH_ONE_SERVICE_REQUEST",
  FETCH_ONE_SERVICE_REQUEST_RESET: "FETCH_ONE_SERVICE_REQUEST_RESET",
  FETCH_ONE_SERVICE_REQUEST_FAILURE: "FETCH_ONE_SERVICE_REQUEST_FAILURE",
  FETCH_ONE_SERVICE_REQUEST_SUCCESS: "FETCH_ONE_SERVICE_REQUEST_SUCCESS",
};
